import geomagnetism from 'geomagnetism';

export default function getDeclination(center: mapboxgl.LngLat) {
    return Math.round(geomagnetism.model().point(center.toArray().reverse()).decl);
}
